module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "15",
      "width": "100",
      "tablet": "0"
    }
  }), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "70"
    }
  }, [_c('router-view', {
    key: 'getting-started-route-' + _vm.$route.path
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "15",
      "width": "100",
      "tablet": "0"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4576ff44","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/GettingStarted/Layout.vue
// module id = 3148
// module chunks = 1